<script>
import gql from 'graphql-tag'

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { rules } from '@/utils/validators'

import { updateViewer } from '@/graph/mutations/user'

export default {
  name: 'PayoutsAddDetailsView',
  mixins: [validationMixin],
  apollo: {
    user: {
      query: gql`
        query {
          user: getViewer {
            id
            paypalAddress
          }
        }
      `,
      fetchPolicy: 'cache-and-network',
      result({ data }) {
        if (!data) return
        const { paypalAddress } = data.user

        this.form = { paypalAddress }
      }
    }
  },
  data() {
    return {
      rules,
      form: {
        paypalAddress: ''
      },

      submitting: false
    }
  },
  methods: {
    goToPayouts() {
      this.$router.replace({ name: 'PayoutsView' })
    },

    submit() {
      if (this.submitting || this.$v.$invalid) return
      this.submitting = true

      const data = this.form

      updateViewer(data)
        .then(this.goToPayouts)
        .finally(() => (this.submitting = false))
    }
  },
  validations: {
    form: {
      paypalAddress: { required, email }
    }
  }
}
</script>

<template>
  <transition name="slide-up" appear>
    <!-- Payouts Add Details View -->
    <div class="view-grid">
      <div>
        <form @submit.prevent="submit()">
          <!-- Payouts View Title -->
          <div class="display-1 font-weight-bold mb-3">
            Payouts
          </div>

          <v-skeleton-loader
            :loading="$apollo.loading"
            transition="fade-transition"
            height="94"
            type="list-item-avatar-two-line"
          >
            <!-- Payout Details -->
            <div class="payouts-view--item mt-6">
              <div class="subtitle-1 font-weight-bold">
                Payout details
              </div>
              <div class="body-2">
                We use PayPal to make sure you get paid on time and keep your
                personal and bank details secure.
              </div>

              <!-- Paypal Address Input -->
              <div class="mt-5 mb-3">
                <v-text-field
                  v-model="form.paypalAddress"
                  :rules="[rules.required, rules.email]"
                  validate-on-blur
                  label="PayPal address"
                  type="email"
                  @blur="$v.form.paypalAddress.$touch()"
                />
              </div>

              <!-- Save Button -->
              <v-btn
                :loading="submitting"
                :disabled="$v.$invalid"
                class="primary"
                rounded
                depressed
                type="submit"
              >
                Save
              </v-btn>
            </div>
          </v-skeleton-loader>
        </form>
      </div>
    </div>
  </transition>
</template>
